import React from "react";

export default function Close({ close, style, img }) {
  return (
    <>
      <div onClick={close}>
        <div className={style}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/${img}.svg`}
            alt="close"
          />
        </div>
      </div>
    </>
  );
}
